import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const CommonSidebar = ({ iconColor, toggleSidebarMobile }) => {

  const [menuActive, setMenuActive] = useState("")

  return (
    <aside
      id="sidebar"
      className="sidebar sticky-top d-lg-block"
      data-bs-theme="theme-FrenchRose"
    >
      <nav className="navbar py-0 d-flex ">
        {/* <!--=== asidebar top logo  ===--> */}
        <ul className="list-unstyled mb-2 py-1 w-100">
          <li>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <Link href="/" className="d-flex align-items-center logo">
                <svg
                  className="me-2 text-primary"
                  width="36"
                  height="36"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M3 21l18 0" />
                  <path d="M3 10l18 0" />
                  <path d="M5 6l7 -3l7 3" />
                  <path d="M4 10l0 11" />
                  <path d="M20 10l0 11" />
                  <path d="M8 14l0 3" />
                  <path d="M12 14l0 3" />
                  <path d="M16 14l0 3" />
                </svg>
                <span className="mb-0 mt-1 title-font h3 text-primary">
                  DashBanker
                </span>
              </Link>
              <button
                className="btn border-0 p-0 pe-2 sidebar-toggle-btn d-lg-none d-block"
                type="button"
                onClick={toggleSidebarMobile}
              >
                <span className="no-thumbnail avatar md rounded-circle ">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right-from-arc"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M15 12h-12"></path>
                    <path d="M7 8l-4 4l4 4"></path>
                    <path d="M12 21a9 9 0 0 0 0 -18"></path>
                  </svg>
                </span>
              </button>
            </div>
          </li>
        </ul>
        {/* <!--============== nav link  =============--> */}
        <ul className={`list-unstyled mb-4 menu-list w-100 ${iconColor}`}>
          {/* <!--=== Dashboard ===--> */}
          <li>
            <NavLink
              onClick={() => setMenuActive("dashboard")}
              className={`nav-link ps-0 ${menuActive === "" ? "active" : ""}`}
              to="/dashboard"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Dashboard"
              data-bs-original-title="Dashboard"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
                <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path>
              </svg>
              <span className="mx-3">Dashboard</span>
            </NavLink>
          </li>
          {/* <!--=== Transactions ===--> */}
          <li>
            <NavLink
              to="transactions"
              onClick={() => setMenuActive("transactions")}
              className={`nav-link ps-0 ${menuActive === "transactions" ? "active" : ""}`}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Transactions"
              data-bs-original-title="Transactions"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M7 10h14l-4 -4"></path>
                <path d="M17 14h-14l4 4"></path>
              </svg>
              <span className="mx-3">Transactions</span>
            </NavLink>
          </li>
          {/* <!--=== Accounts ===--> */}
          <li>
            <NavLink
              to="accounts"
              onClick={() => setMenuActive("accounts")}
              className={`nav-link ps-0 ${menuActive === "accounts" ? "active" : ""}`}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Accounts"
              data-bs-original-title="Accounts"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
              </svg>
              <span className="mx-3">Accounts</span>
            </NavLink>
          </li>
          {/* <!--=== Investments ===--> */}
          <li>
            <NavLink
              to="investments"
              onClick={() => setMenuActive("investments")}
              className={`nav-link ps-0 ${menuActive === "investments" ? "active" : ""}`}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Investments"
              data-bs-original-title="Investments"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M16 15h5v7l-2.5 -1.5l-2.5 1.5z"></path>
                <path d="M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h5"></path>
                <path d="M9 21v-6a2 2 0 0 1 2 -2h1.5"></path>
              </svg>
              <span className="mx-3">Investments</span>
            </NavLink>
          </li>
          {/* <!--=== Credit Cards ===--> */}
          <li>
            <NavLink
              to="credit-cards"
              onClick={() => setMenuActive("credit-cards")}
              className={`nav-link ps-0 ${menuActive === "credit-cards" ? "active" : ""}`}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Credit Cards"
              data-bs-original-title="Credit Cards"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M3 5m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"></path>
                <path d="M3 10l18 0"></path>
                <path d="M7 15l.01 0"></path>
                <path d="M11 15l2 0"></path>
              </svg>
              <span className="mx-3">Credit Cards</span>
            </NavLink>
          </li>
          {/* <!--=== Loans ===--> */}
          <li>
            <NavLink
              to="loans"
              onClick={() => setMenuActive("loans")}
              className={`nav-link ps-0 ${menuActive === "loans" ? "active" : ""}`}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Loans"
              data-bs-original-title="Loans"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M20.876 10.51a9 9 0 1 0 -7.839 10.43"></path>
                <path d="M3.6 9h16.8"></path>
                <path d="M3.6 15h9.9"></path>
                <path d="M11.5 3a17 17 0 0 0 0 18"></path>
                <path d="M12.5 3a16.986 16.986 0 0 1 2.578 9.02"></path>
                <path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"></path>
                <path d="M19 21v1m0 -8v1"></path>
              </svg>
              <span className="mx-3">Loans</span>
            </NavLink>
          </li>
          {/* <!--=== Services ===--> */}
          <li>
            <Link
              to="#services"
              data-bs-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle ps-0 py-0  nav-link "
              aria-label="Authentication"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4"></path>
                <path d="M14.5 5.5l4 4"></path>
                <path d="M12 8l-5 -5l-4 4l5 5"></path>
                <path d="M7 8l-1.5 1.5"></path>
                <path d="M16 12l5 5l-4 4l-5 -5"></path>
                <path d="M16 17l-1.5 1.5"></path>
              </svg>
              <span className="mx-3">Services</span>
            </Link>
            <ul className="list-unstyled collapse drop_link_menu" id="services">
              {/* <!--=== Service ===--> */}
              <li>
                <NavLink
                  to="services"
                  onClick={() => setMenuActive("services")}
                  className={`nav-link ps-0 ${menuActive === "services" ? "active" : ""}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Services"
                  data-bs-original-title="Services"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4"></path>
                    <path d="M14.5 5.5l4 4"></path>
                    <path d="M12 8l-5 -5l-4 4l5 5"></path>
                    <path d="M7 8l-1.5 1.5"></path>
                    <path d="M16 12l5 5l-4 4l-5 -5"></path>
                    <path d="M16 17l-1.5 1.5"></path>
                  </svg>
                  <span className="mx-3">Service</span>
                </NavLink>
              </li>
              {/* <!--=== Business Loan ===--> */}
              <li className="ms-0">
                <NavLink
                  to="business-loan"
                  onClick={() => setMenuActive("business-loan")}
                  className={`nav-link ps-0 ${menuActive === "business-loan" ? "active" : ""}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="business Loan"
                  data-bs-original-title="business Loan"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M16 6m-5 0a5 3 0 1 0 10 0a5 3 0 1 0 -10 0" />
                    <path d="M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4" />
                    <path d="M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4" />
                    <path d="M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4" />
                    <path d="M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
                    <path d="M5 15v1m0 -8v1" />
                  </svg>
                  <span className="mx-3">Business Loan</span>
                </NavLink>
              </li>
              {/* <!--===Savings Accounts  ===--> */}
              <li className="ms-0">
                <NavLink
                  to="savings-accounts"
                  onClick={() => setMenuActive("savings-accounts")}
                  className={`nav-link ps-0 ${menuActive === "savings-accounts" ? "active" : ""}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Savings Accounts"
                  data-bs-original-title="Savings Accounts"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                    <path d="M6 21v-2a4 4 0 0 1 4 -4h2.5"></path>
                    <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"></path>
                    <path d="M19 18v.01"></path>
                  </svg>
                  <span className="mx-3">Savings Accounts</span>
                </NavLink>
              </li>
              {/* <!--=== Life Insurance ===--> */}
              <li className="ms-0">
                <NavLink
                  to="life-Insurance"
                  onClick={() => setMenuActive("life-Insurance")}
                  className={`nav-link ps-0 ${menuActive === "life-Insurance" ? "active" : ""}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Life Insurance"
                  data-bs-original-title="Life Insurance"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11" />
                    <path d="M9 7l4 0" />
                    <path d="M9 11l4 0" />
                  </svg>
                  <span className="mx-3">Life Insurance</span>
                </NavLink>
              </li>
              {/* <!--=== Personal Loan ===--> */}
              <li className="ms-0">
                <NavLink
                  to="/personal-loans"
                  onClick={() => setMenuActive("personal-s")}
                  className={`nav-link ps-0 ${menuActive === "personal-loans" ? "active" : ""}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Personal Loan "
                  data-bs-original-title="Personal Loan "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 21l18 0" />
                    <path d="M3 10l18 0" />
                    <path d="M5 6l7 -3l7 3" />
                    <path d="M4 10l0 11" />
                    <path d="M20 10l0 11" />
                    <path d="M8 14l0 3" />
                    <path d="M12 14l0 3" />
                    <path d="M16 14l0 3" />
                  </svg>
                  <span className="mx-3">Personal Loan</span>
                </NavLink>
              </li>
            </ul>
          </li>
          {/* <!--===My Privileges  ===--> */}
          <li>
            <NavLink
              to="/privileges"
              onClick={() => setMenuActive("privileges")}
              className={`nav-link ps-0 ${menuActive === "privileges" ? "active" : ""}`}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Privileges"
              data-bs-original-title="Privileges"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"></path>
                <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"></path>
                <path d="M9.7 17l4.6 0"></path>
              </svg>
              <span className="mx-3">My Privileges</span>
            </NavLink>
          </li>
          {/* <!--=== Setting ===--> */}
          <li>
            <NavLink
              to="setting"
              onClick={() => setMenuActive("setting")}
              className={`nav-link ps-0 ${menuActive === "setting" ? "active" : ""}`}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Setting"
              data-bs-original-title="Setting"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
                <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
              </svg>
              <span className="mx-3">Setting</span>
            </NavLink>
          </li>
          {/* <!--============== Authentication =============--> */}
          <li>
            <Link
              to="#Authentication"
              data-bs-toggle="collapse"
              aria-expanded="false"
              className="dropdown-toggle ps-0 py-0  nav-link "
              aria-label="Authentication"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"></path>
                <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"></path>
                <path d="M8 11v-4a4 4 0 1 1 8 0v4"></path>
              </svg>
              <span className="mx-3">Authentication</span>
            </Link>
            <ul className="list-unstyled collapse drop_link_menu" id="Authentication">
              {/* <!--=== Sign in ===--> */}
              <li className="ms-0">
                <NavLink
                  to="signin"
                  onClick={() => setMenuActive("signin")}
                  className={`nav-link ps-0 ${menuActive === "signin" ? "active" : ""}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Sign in"
                  data-bs-original-title="Sign in"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                    <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                  </svg>
                  <span className="mx-3">Sign in</span>
                </NavLink>
              </li>
              {/* <!--===Sign up  ===--> */}
              <li className="ms-0">
                <NavLink
                  to="signup"
                  onClick={() => setMenuActive("signup")}
                  className={`nav-link ps-0 ${menuActive === "signup" ? "active" : ""}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Sign up"
                  data-bs-original-title="Sign up"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                    <path d="M6 21v-2a4 4 0 0 1 4 -4h2.5"></path>
                    <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"></path>
                    <path d="M19 18v.01"></path>
                  </svg>
                  <span className="mx-3">Sign up</span>
                </NavLink>
              </li>
              {/* <!--=== Password reset ===--> */}
              <li className="ms-0">
                <NavLink
                  to="password-reset"
                  onClick={() => setMenuActive("password-reset")}
                  className={`nav-link ps-0 ${menuActive === "password-reset" ? "active" : ""}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Password reset"
                  data-bs-original-title="Password reset"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"></path>
                    <path d="M8 11v-4a4 4 0 1 1 8 0v4"></path>
                    <path d="M15 16h.01"></path>
                    <path d="M12.01 16h.01"></path>
                    <path d="M9.02 16h.01"></path>
                  </svg>
                  <span className="mx-3">Password reset</span>
                </NavLink>
              </li>
              {/* <!--=== 2-Step Authentication ===--> */}
              <li className="ms-0">
                <NavLink
                  to="two-step"
                  onClick={() => setMenuActive("two-step")}
                  className={`nav-link ps-0 ${menuActive === "two-step" ? "active" : ""}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="2-Step Authentication"
                  data-bs-original-title="2-Step Authentication"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06"></path>
                    <path d="M15 19l2 2l4 -4"></path>
                  </svg>
                  <span className="mx-3">Authentication</span>
                </NavLink>
              </li>
              {/* <!--=== Lockscreen ===--> */}
              <li className="ms-0">
                <NavLink
                  to="lockscreen"
                  className="nav-link ps-0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Lockscreen"
                  data-bs-original-title="Lockscreen"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M4 8v-2c0 -.554 .225 -1.055 .588 -1.417"></path>
                    <path d="M4 16v2a2 2 0 0 0 2 2h2"></path>
                    <path d="M16 4h2a2 2 0 0 1 2 2v2"></path>
                    <path d="M16 20h2c.55 0 1.05 -.222 1.41 -.582"></path>
                    <path d="M15 11a1 1 0 0 1 1 1m-.29 3.704a1 1 0 0 1 -.71 .296h-6a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h2"></path>
                    <path d="M10 11v-1m1.182 -2.826a2 2 0 0 1 2.818 1.826v1"></path>
                    <path d="M3 3l18 18"></path>
                  </svg>
                  <span className="mx-3">Lockscreen</span>
                </NavLink>
              </li>
              {/* <!--=== Maintenance ===--> */}
              <li className="ms-0">
                <NavLink
                  to="maintenance"
                  className="nav-link ps-0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Maintenance"
                  data-bs-original-title="Maintenance"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                    <path d="M15 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                    <path d="M5 20h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"></path>
                    <path d="M3 6l9 -4l9 4"></path>
                  </svg>
                  <span className="mx-3">Maintenance</span>
                </NavLink>
              </li>
            </ul>
          </li>
          {/* <!--============== Documentation =============--> */}
          <li>
            <NavLink
              to="/docs/documentation"
              className="nav-link ps-0"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Setting"
              data-bs-original-title="Setting"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
                <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
              </svg>
              <span className="mx-3">Documentation</span>
            </NavLink>
          </li>
        </ul >
      </nav >
    </aside >
  );
};

export default CommonSidebar;
